import cryptodotcom from "./cryptodotcom.png";
import dc from "./dc.png";
import fb from "./fb.png";
import ig from "./ig.png";
import ldin from "./ldin.png";
import rdt from "./rdt.png";
import tlg from "./tlg.png";
import twx from "./twx.png";
import yt from "./yt.png";


const Socials = {
  cryptodotcom: cryptodotcom,
  dc: dc,
  fb: fb,
  ig: ig,
  ldin: ldin,
  rdt: rdt,
  tlg: tlg,
  twx: twx,
  yt: yt,
};

export default Socials;
